import { COLOR_TOOL_PALETTE } from './ColorToolOption.constants';

export const getColorToolOptionKey = (color?: string): string => {
  const [key] = Object.entries(COLOR_TOOL_PALETTE).find(([key, c]) => c === color?.toLowerCase()) ?? [];
  return key ?? '';
};
